import { JSONObject } from 'global/graphql/scalars.type';

export const DEFAULT_COLOUR = '#ffffff';
export const SQUARE_IMAGE_KEY = 'squareImageKey';
export const SQUARE_IMAGE_CROP_FIELD = 'squareImageCrop';
export const UPLOADED_FILE_FIELD = 'uploaded';
export const NAME_FIELD = 'name';
export const DESCRIPTION_FIELD = 'description';
export const ALT_TEXT_FIELD = 'altText';
export const TYPE_FIELD = 'type';
export const LINK_FIELD = 'link';
export const LINK_URL_FIELD = 'linkUrl';
export const BACKUP_LINK_URL_FIELD = 'backupLinkUrl';
export const FILE_NAME = 'fileName';
export const ASSET_KEY = 'assetKey';
export const SQUARE_IMAGE_FILE_NAME = 'squareImageFileName';
export const DURATION_FIELD = 'duration';
export const IMAGE_PREVIEW_URL = 'imagePreviewUrl';
export const IMAGE_CLASSIFICATION_FIELD = 'imageClassification';
export const GUIDED_RESEARCH_FIELD = 'guidedResearch';
export const IMAGE_FILE_KEY_FIELD = 'imageKey';
export const COVER_IMAGE_KEY_FIELD = 'coverImageKey';
export const COVER_IMAGE_CROP_FIELD = 'coverImageCrop';
export const COVER_IMAGE_FILE_FIELD = 'coverImageFile';
export const COVER_IMAGE_FILE_NAME = 'coverImageFileName';
export const COVER_IMAGE_PREVIEW_URL = 'coverImagePreviewUrl';
export const ATTRIBUTION_AUTHOR = 'attributionAuthor';
export const ATTRIBUTION_COPYRIGHT = 'attributionCopyright';
export const ATTRIBUTION_LICENCE = 'attributionLicence';
export const ATTRIBUTION_MODIFICATIONS = 'attributionModifications';
export const ATTRIBUTION_MODIFICATION_DESCRIPTION =
  'attributionModificationDescription';
export const CONTENT_WARNING = 'contentWarning';
export const IS_MENTOR_TEXT_FIELD = 'isMentorText';
export const GUIDED_READ_THROUGH_IDS_FIELD = 'guidedReadThroughIds';
export const GUIDED_READ_THROUGHS_CHANGES_FIELD = 'guidedReadThroughsChanges';

export type ImageUploadFormFields = {
  uploadedFile: typeof UPLOADED_FILE_FIELD | typeof COVER_IMAGE_FILE_FIELD;
  imageCrop: typeof SQUARE_IMAGE_CROP_FIELD | typeof COVER_IMAGE_CROP_FIELD;
  imageFileName: typeof SQUARE_IMAGE_FILE_NAME | typeof COVER_IMAGE_FILE_NAME;
  imageKey: typeof SQUARE_IMAGE_KEY | typeof COVER_IMAGE_KEY_FIELD;
  generatedPreviewUrl:
    | typeof IMAGE_PREVIEW_URL
    | typeof COVER_IMAGE_PREVIEW_URL;
};

export type GuidedResearch = {
  link?: string;
  title: string;
  description: JSONObject;
};
